/* eslint-disable import/no-cycle */
import React from "react";
import Routers from "./routers";
import "./App.css";

function App() {
  return <Routers />;
}

export default App;
